(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/reductions.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/reductions.js');
"use strict";


const Reductions = _ref => {
  let reductionLabels = _ref.reductionLabels;
  if (!Array.isArray(reductionLabels) || reductionLabels.length === 0) {
    return null;
  }
  return React.createElement("div", {
    className: "event__reductions"
  }, React.createElement("div", {
    className: "event__reduction__label"
  }, reductionLabels.length > 0 && React.createElement(React.Fragment, null, "Reducerat", reductionLabels.map(reduction => React.createElement("div", {
    className: "event__reduction",
    key: reduction
  }, reduction)))));
};
setGlobal('svs.components.poolBetting.printableCoupon.Reductions', Reductions);

 })(window);